<script lang="ts" setup>
// 1. Import 'watch' dan 'useColors'
import { onMounted, watch } from 'vue'
import { useSettingsStore } from './stores/settings' // Sesuaikan path
import { useColors } from 'vuestic-ui' // <-- IMPORT useColors

// 2. Siapkan store dan Vuestic colors
const settingsStore = useSettingsStore()
const { setColors } = useColors() // Ambil fungsi 'setColors'

// 3. Panggil fetch saat aplikasi dimuat (tetap sama)
onMounted(() => {
  settingsStore.fetchPublicSettings()
})

// 4. Tambahkan 'watch' untuk menerapkan warna
//    Ini akan memantau 'isLoading' di store
watch(
  () => settingsStore.isLoading,
  (isLoading) => {
    // Saat loading SELESAI (berubah menjadi 'false')
    if (!isLoading) {
      // Ambil nilai warna dari getters store
      const primary = settingsStore.primaryColor
      const secondary = settingsStore.secondaryColor
      const background = settingsStore.backgroundColor

      // Siapkan objek warna baru
      const newColors: { [key: string]: string } = {}

      // Hanya tambahkan jika nilainya ada (tidak null/kosong)
      if (primary) newColors.primary = primary
      if (secondary) newColors.secondary = secondary
      if (background) newColors.background = background // Vuestic mengerti 'background'

      // Terapkan warna-warna ini ke seluruh tema Vuestic UI!
      if (Object.keys(newColors).length > 0) {
        setColors(newColors)
      }

      // --- Bagian 2: Terapkan Favicon (LOGIKA BARU) ---
      const favicon = settingsStore.faviconUrl
      if (favicon) {
        // 1. Cari tag <link rel="icon"> yang ada di index.html
        let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']")

        // 2. Jika tidak ada, buat baru
        if (!link) {
          link = document.createElement('link')
          link.rel = 'icon'
          document.head.appendChild(link)
        }

        // 3. Set 'href'-nya ke URL favicon dari database
        link.href = favicon
      }
    }
  },
)
</script>

<template>
  <RouterView />
</template>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
